var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.799 76.045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.305-53.213a2.114,2.114,0,0,0,.8-.232c5.932-2.869,8.042-4.658,8.042-8.286v-7.141a2.758,2.758,0,0,0-1.981-3.037c-.823-.347-4.362-1.48-5.1-1.7a6.518,6.518,0,0,0-1.763-.27,7.073,7.073,0,0,0-1.776.27c-.733.206-4.272,1.351-5.1,1.7a2.758,2.758,0,0,0-1.981,3.037v7.141c0,3.628,2.136,5.378,8.042,8.286A2.107,2.107,0,0,0,23.305-53.213Zm-3.757-7.128v-3.873c0-.669.257-1.055.759-1.184v-.991a3.01,3.01,0,0,1,3-3.332,3.01,3.01,0,0,1,3,3.332v.991c.489.129.746.515.746,1.184v3.873c0,.875-.4,1.261-1.2,1.261H20.745C19.947-59.08,19.548-59.466,19.548-60.341Zm2.522-5.121h2.458v-1c0-.926-.489-1.518-1.235-1.518s-1.222.592-1.222,1.518Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.2401c16658acd0506e0ab927e0290dbd.svg";
export { ForwardRef as ReactComponent };